@value header-height: 56px;
@value list-footer-height: 84px;
@value banner-height: 92px;
@value cue-card-height: 116px;

.wrapper {
    width: 400px;
    background-color: white;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1005;
    border-left: 1px solid var(--off-white-dk);
}

.header {
    height: 56px;
    background-color: var(--off-white);
}

.header-sub-title-container {
    max-width: 220px;
}

.header-close-button {
    position: absolute;
    right: 0;
    margin-right: 16px;
}

.header-back-button {
    position: absolute;
    left: 0;
    margin-left: 16px;
}

.header-reset-button {
    position: absolute;
    right: 55px;
    margin-bottom: 4px;
}

.home-container {
    padding: 0 16px;
    margin: 16px 0;
    height: 100%;
}

.home-container-agent-view {
    height: calc(100% - header-height - 8px); /* 56px (header) - 8px (padding) */
    margin: 0;
}

.home-container-list-view {
    height: calc(100% - header-height - list-footer-height); /* 56px (header) - 66px (footer) */
    overflow-y: scroll;
}

.home-container-disabled {
    opacity: 0.6;
    height: calc(100% - header-height - list-footer-height - banner-height);
}

.home-container-has-cue-card {
    height: calc(100% - header-height - list-footer-height - cue-card-height);
}

/* Add a rule for if disabled and has cue card */
.home-container-disabled.home-container-has-cue-card {
    height: calc(100% - header-height - list-footer-height - cue-card-height - banner-height);
}

.i-frame-container {
    height: 100%;
    width: 100%;
}

/* TeamAI Iframe has a minimum height for it's elements that causes the sidebar
to get cut off. This adds a vertical scrollbar to reveal the hidden content on
small height screens. */
@media (max-height: 770px) {
    .i-frame-container {
        overflow-y: auto;
    }
}

.cue-card-container {
    height: 100px;
}
